import { motion } from 'framer-motion';

const advisors = [
  {
    initials: 'AS',
    name: 'Dr. Asim Salim',
    title: 'Founding Clinical Advisor',
    specialty: 'Pediatrician',
    bio: "Practicing pediatrician guiding PulseStack AI's clinical accuracy, specialty template design, and workflow fit for frontline physicians.",
  },
  {
    initials: 'KH',
    name: 'Dr. Khalid Hussain',
    title: 'Medical Advisor',
    specialty: 'Strategic Partnerships',
    bio: 'Advising on clinical adoption pathways, healthcare network partnerships, and physician-led go-to-market strategy across Ontario.',
  },
];

export default function AdvisorQuote() {
  return (
    <section className="bg-gray-50 border-y border-gray-100 py-16 md:py-20">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <p className="section-label">Clinical Advisors</p>
          <h2 className="mt-3 section-heading">Guided by practicing physicians</h2>
          <p className="mt-4 section-sub max-w-xl mx-auto">
            The clinical accuracy and workflow design behind our products is shaped by
            physicians who still see patients every week.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {advisors.map((advisor, i) => (
            <motion.div
              key={advisor.name}
              className="bg-white rounded-2xl border border-gray-200 p-7 flex items-start gap-5 hover:border-primary-200 hover:shadow-md transition-all duration-200"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: i * 0.1 }}
            >
              {/* PLACEHOLDER: Replace initials div with:
                  <img src="/headshots/asim_salim_headshot.jpg" alt="Dr. Asim Salim"
                       className="flex-shrink-0 h-14 w-14 rounded-xl object-cover" />
              */}
              <div className="flex-shrink-0 h-14 w-14 rounded-xl bg-primary-50 flex items-center justify-center font-bold text-base text-primary-700 select-none">
                {advisor.initials}
              </div>
              <div>
                <p className="font-bold text-gray-900">{advisor.name}</p>
                <p className="text-sm text-primary-600 font-medium mt-0.5">{advisor.title}</p>
                <p className="text-xs text-gray-400 mt-0.5">{advisor.specialty}</p>
                <p className="text-sm text-gray-500 leading-relaxed mt-3">{advisor.bio}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* PLACEHOLDER: Add a full-width blockquote here when Dr. Asim Salim's quote is confirmed.
            Example structure:
            <blockquote className="mt-10 text-xl md:text-2xl font-medium text-gray-900 text-center italic max-w-3xl mx-auto">
              "Quote text here."
              <footer className="mt-4 text-sm text-gray-500 not-italic font-normal">
                — Dr. Asim Salim, MD · Founding Clinical Advisor
              </footer>
            </blockquote>
        */}
      </div>
    </section>
  );
}
